import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { environment } from '../../../environments/environment';

@Injectable()
export class RoleService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        ) {}
    public getRoles(): Observable<any> {
        return this._http.get(this.baseUrl + `${API.ROLE.GET_ROLES}`);
    }
}